import React, { useState } from 'react'
import { COLORES } from '../../../../config/colores'
import CampoEditable from './CampoEditable'
import { reduxForm, formValueSelector } from 'redux-form'
import { FORM_ESTIMACION_STOCK } from '../../../../config/forms'
import { connect } from 'react-redux'
import { updateParametroCumplimiento, obtenerParametroCumplimiento } from '../../actions'
import { restoreCumplimiento, obtenerEstimacionSemanal } from '../../actions/listados'

function CumplimientoCupos (props) {
  const { cumplimiento, change: formChange, cumplimientoPorcentaje } = props
  const [porcentaje, setProcentaje] = useState(cumplimiento)

  const handleInputBlur = async () => {
    if (cumplimientoPorcentaje && cumplimientoPorcentaje !== porcentaje) {
      props.updateParametroCumplimiento(cumplimientoPorcentaje)
      setProcentaje(cumplimientoPorcentaje)
      props.obtenerEstimacionSemanal()
    }
  }

  const handleDisplayClick = () => {
    formChange('cumplimientoPorcentaje', porcentaje)
  }

  return (
    <CampoEditable
      titulo='Cumplimiento de cupos por defecto'
      name='cumplimientoPorcentaje'
      handleInputBlur={handleInputBlur}
      handleDisplayClick={handleDisplayClick}
      valor={`${porcentaje} %`}
      backgroundColor={COLORES.violet}
    />
  )
}

const selector = formValueSelector(FORM_ESTIMACION_STOCK)
const mapStateToProps = (state) => ({
  cumplimientoPorcentaje: selector(state, 'cumplimientoPorcentaje'),
  cerealEstimacionStock: state.stock.cerealEstimacionStock
})

const mapActionsToProps = {
  obtenerParametroCumplimiento,
  updateParametroCumplimiento,
  restoreCumplimiento,
  obtenerEstimacionSemanal
}

const withRedux = connect(mapStateToProps, mapActionsToProps)

const withReduxForm = reduxForm({
  form: FORM_ESTIMACION_STOCK,
  destroyOnUnmount: false
})
export default withRedux(withReduxForm(CumplimientoCupos))
